<template>
  <div>
    <div class="row-v2">
      <div class="col" style="max-width: 700px">
        <div class="col__box">
          <div class="alert alert-warning">
            <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
            <strong>Lưu ý!</strong> Hãy tìm kiếm phim trước khi yêu cầu nhé
          </div>
          <form action="/action_page.php">
            <div class="form-group">
              <label for="movie_name">Tên phim:</label>
              <input type="text" class="form-control" name="movie_name" v-model="movie_name">
            </div>
            <div class="form-group">
              <label for="">Link review (Imdb, Mydramalist, ....)</label>
              <input type="text" class="form-control" name="">
            </div>
            <div class="form-group">
              <label for="description">Mô tả phim</label>
              <textarea-autosize placeholder="Type something here..." class="form-control" v-model="description" rows="2" />
            </div>
            <div class="form-group">
              <label for="link_download">Link tải (Nếu có)</label>
              <textarea-autosize placeholder="Type something here..." class="form-control" v-model="links" rows="2" />
            </div>
            <button type="submit" class="btn btn-default">Submit</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {

  name: 'request-movie__index',

  data() {
    return {
      movie_name: '',
      description: '',
      links: '',
    };
  },
  created() {
    this.setTitle(this.$t('request-movie'));
  }
}

</script>
<style lang="css" scoped>
</style>
